import React, { useState } from 'react';

const MIN = 8;
const MSG = {
  WRONG: '현재 비밀번호가 맞지 않습니다.',
  SHORT: `새 비밀번호는 ${MIN}자 이상이어야 합니다.`,
  SAME:  '현재 비밀번호와 다르게 정해 주세요.',
  DB:    '저장 중 오류가 났습니다. 잠시 후 다시 시도해 주세요.',
};

function AdminPassword({ token }) {
  const [cur, setCur] = useState('');
  const [next, setNext] = useState('');
  const [again, setAgain] = useState('');
  const [state, setState] = useState(null);   // null | 'saving' | 'ok'
  const [error, setError] = useState('');

  const submit = (e) => {
    e.preventDefault();
    setError('');
    if (next !== again) { setError('새 비밀번호가 서로 다릅니다.'); return; }
    if (next.length < MIN) { setError(MSG.SHORT); return; }
    setState('saving');
    fetch('/api/admin/password', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Authorization: 'Bearer ' + token },
      body: JSON.stringify({ current: cur, next }),
    })
      .then((r) => r.json())
      .then((d) => {
        if (d && d.success) {
          setState('ok'); setCur(''); setNext(''); setAgain('');
        } else {
          setState(null); setError(MSG[d && d.error] || '변경하지 못했습니다.');
        }
      })
      .catch(() => { setState(null); setError(MSG.DB); });
  };

  return (
    <div className="ad-card ad-narrow">
      <h3 className="ad-card-h">비밀번호 변경</h3>
      <p className="ad-card-sub">
        바꾸면 <b>다른 기기의 로그인은 모두 끊깁니다.</b> 지금 쓰는 창만 유지됩니다.
      </p>
      <form onSubmit={submit}>
        <div className="admin-field">
          <label htmlFor="pw-cur">현재 비밀번호</label>
          <input id="pw-cur" type="password" value={cur} autoComplete="current-password"
                 onChange={(e) => setCur(e.target.value)} required />
        </div>
        <div className="admin-field">
          <label htmlFor="pw-new">새 비밀번호 <span className="ad-hint">{MIN}자 이상</span></label>
          <input id="pw-new" type="password" value={next} autoComplete="new-password"
                 onChange={(e) => setNext(e.target.value)} required />
        </div>
        <div className="admin-field">
          <label htmlFor="pw-re">새 비밀번호 확인</label>
          <input id="pw-re" type="password" value={again} autoComplete="new-password"
                 onChange={(e) => setAgain(e.target.value)} required />
        </div>
        <button type="submit" className="admin-btn-primary" disabled={state === 'saving'}>
          {state === 'saving' ? '변경 중…' : '비밀번호 변경'}
        </button>
        {error && <div className="ad-msg err">{error}</div>}
        {state === 'ok' && <div className="ad-msg ok">변경되었습니다.</div>}
      </form>
    </div>
  );
}

export default AdminPassword;
